import { render, staticRenderFns } from "./main-posts.vue?vue&type=template&id=e7a64214&scoped=true&"
import script from "./main-posts.vue?vue&type=script&lang=js&"
export * from "./main-posts.vue?vue&type=script&lang=js&"
import style0 from "./main-posts.vue?vue&type=style&index=0&id=e7a64214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a64214",
  null
  
)

export default component.exports